/** Strip dangerous tags/attributes from rich HTML pasted or produced by contentEditable. */
export function sanitizeRichHtml(html: string): string {
  const d = document.createElement('div');
  d.innerHTML = html;
  d.querySelectorAll('script,style,iframe,object,embed,link,meta').forEach((el) => el.remove());
  for (const el of d.querySelectorAll('*')) {
    for (const { name } of [...el.attributes]) {
      if (name.startsWith('on') || name === 'javascript:') el.removeAttribute(name);
    }
    if (el.tagName === 'A') {
      const href = el.getAttribute('href');
      if (href && /^\s*javascript:/i.test(href)) el.removeAttribute('href');
    }
  }
  return d.innerHTML;
}
